import { Component } from '@angular/core';
import { TitleService } from '../../../services/title.service';

@Component({
    selector: 'app-integratori',
    imports: [],
    templateUrl: './integratori.component.html',
    styleUrl: './integratori.component.css'
})
export class IntegratoriComponent {
  constructor(private ts : TitleService) {  }

  ngOnInit(){
    this.ts.titolo = "Integratori e alimenti per lo sport";
  }
}
